// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Xy6OT","fullView":"styles_fullView__1r1N3"};